import React from 'react';
import { CaretDownFill } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';
import { MOBILE_UI } from '../../constants/mobileUi';

const TONE = {
  primary: { height: 48, fontSize: 15, fontWeight: 700, padX: 16, maxWidth: 240, surface: 'input' },
  secondary: { height: 40, fontSize: 13, fontWeight: 600, padX: 12, maxWidth: 240, surface: 'input' },
  tertiary: { height: 40, fontSize: 12, fontWeight: 600, padX: 10, maxWidth: 132, surface: 'chip' },
};

/**
 * Pill-shaped filter trigger for mobile toolbars. Either opens a sheet (`trailing="caret"`)
 * or acts as an inline toggle (`trailing="none"` with a leading icon).
 */
const FilterChip = ({
  label = null,
  value = null,
  active = false,
  onClick,
  leadingIcon = null,
  trailing = 'caret',
  ariaLabel,
  ariaExpanded,
  title,
  testId,
  maxWidth,
  fill = false,
  tone = null,
}) => {
  const { colors } = useTheme();
  const toneStyle = TONE[tone];
  const restingBg = toneStyle?.surface === 'input'
    ? (colors.bgInput || colors.bgCard)
    : (colors.bgSecondary || colors.bgCard);

  return (
    <button
      type="button"
      className="mobile-filter-chip"
      data-testid={testId}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      aria-pressed={trailing === 'none' ? active : undefined}
      title={title}
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: fill ? 'space-between' : undefined,
        gap: 6,
        flex: fill ? '1 1 auto' : '0 0 auto',
        width: fill ? '100%' : undefined,
        height: toneStyle?.height ?? MOBILE_UI.chipHeight,
        padding: `0 ${toneStyle?.padX ?? 12}px`,
        borderRadius: MOBILE_UI.radiusChip,
        border: `1px solid ${active ? colors.primary : colors.border}`,
        backgroundColor: active ? `${colors.primary}1A` : restingBg,
        color: active ? colors.primary : colors.text,
        fontSize: toneStyle?.fontSize ?? MOBILE_UI.font.body,
        fontWeight: toneStyle?.fontWeight ?? 600,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        maxWidth: fill ? 'none' : (maxWidth ?? toneStyle?.maxWidth ?? 168),
        boxSizing: 'border-box',
      }}
    >
      {leadingIcon}
      {label ? (
        <span style={{ color: colors.textMuted, fontWeight: 600 }}>{label}</span>
      ) : null}
      {value != null ? (
        <span
          style={{
            fontWeight: 700,
            minWidth: 0,
            flex: fill ? '1 1 auto' : undefined,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'left',
          }}
        >
          {value}
        </span>
      ) : null}
      {trailing === 'caret' ? (
        <CaretDownFill size={9} style={{ color: colors.textMuted, flexShrink: 0 }} />
      ) : null}
    </button>
  );
};

export default FilterChip;
